"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const files_1 = require("./files");
function fixData(data, contentType) {
    if (typeof data == "string") {
        return files_1.base64ToBlob(data, contentType);
    }
    else {
        return data;
    }
}
/**Descarga un Blob*/
function download(data, filename) {
    data = fixData(data, undefined);
    const a = document.createElement("a");
    a.style.display = "none";
    document.body.appendChild(a);
    const url = window.URL.createObjectURL(data);
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
}
exports.download = download;
/**Abre un PDF en un nuevo tab
 * @param data El PDF
 * @param title El titulo del tab
 */
function openPdf(data, title) {
    const blob = fixData(data, "application/pdf");
    const url = URL.createObjectURL(blob);
    const w = window.open();
    if (!w) {
        throw new Error("No se pudo abrir la impresión de PDF");
    }
    w.document.write(`
        <html>
            <head>
                <title>
                    ${title}
                </title>"
            </head>
            <body
                style="background-color: rgb(38,38,38); height: 100%; width: 100%; overflow: hidden; margin: 0"
            >
                <embed 
                    width="100%" 
                    height="100%"
                    type="application/pdf"
                    src="${url}"
                    >
            </body>
        </html>
        `);
    setTimeout(() => URL.revokeObjectURL(url), 5 * 60 * 1000);
}
exports.openPdf = openPdf;
/**Abre el cuadro de dialogo de impresión del navegador para un PDF
 * @param data El PDF
 */
function printPdf(data) {
    const blob = fixData(data, "application/pdf");
    const url = URL.createObjectURL(blob);
    const ifr = document.createElement("iframe");
    ifr.src = url;
    ifr.style.display = "none";
    document.body.appendChild(ifr);
    if (ifr.contentWindow) {
        ifr.contentWindow.print();
    }
    setTimeout(() => {
        URL.revokeObjectURL(url);
        document.body.removeChild(ifr);
    }, 5 * 60 * 1000);
}
exports.printPdf = printPdf;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/downloadjs.js
// module id = 298
// module chunks = 0